import styled from 'styled-components';
import type { CaseStatusFeedbackTone } from '@/services/api/flightChanges/mappers/mapCaseStatusToPillConfig';

const toRem = (px: number) => `${px / 16}rem`;

const feedbackBackground = (
    tone: CaseStatusFeedbackTone,
    theme: {
        tokens: {
            color: {
                surface: {
                    infoSoft: string;
                    warningSoft: string;
                    errorSoft: string;
                    successSoft: string;
                };
            };
        };
    },
) => {
    const map: Record<CaseStatusFeedbackTone, string> = {
        info: theme.tokens.color.surface.infoSoft,
        warning: theme.tokens.color.surface.warningSoft,
        error: theme.tokens.color.surface.errorSoft,
        success: theme.tokens.color.surface.successSoft,
    };
    return map[tone];
};

/** Soft feedback pills using theme tokens (matches pre–Hangar-Tag bandeja styling). */
export const StatusPill = styled.span<{ $tone: CaseStatusFeedbackTone }>`
    align-items: center;
    border-radius: ${({ theme }) => toRem(theme.tokens.border.radius.pill)};
    box-sizing: border-box;
    color: ${({ theme }) => theme.tokens.color.text.tertiary};
    display: inline-flex;
    font-family: inherit;
    font-size: ${({ theme }) => toRem(theme.tokens.fonts.size['0875'])};
    font-weight: ${({ theme }) => theme.tokens.fonts.weight.bold};
    justify-content: center;
    line-height: ${({ theme }) => toRem(theme.tokens.fonts.lineHeight['0875'])};
    max-width: ${toRem(200)};
    min-width: 0;
    overflow-wrap: break-word;
    padding: ${({ theme }) => toRem(theme.tokens.padding.xs)} ${({ theme }) => toRem(theme.tokens.padding.sm)};
    word-break: break-word;
    background-color: ${({ theme, $tone }) => feedbackBackground($tone, theme)};
`;

export const StatusPillNeutral = styled.span`
    align-items: center;
    background-color: ${({ theme }) =>
        theme.tokens.components.indicator.variant.base.color.standard.neutralSoft};
    border-radius: ${({ theme }) => toRem(theme.tokens.border.radius.pill)};
    box-sizing: border-box;
    color: ${({ theme }) => theme.tokens.color.text.primary};
    display: inline-flex;
    font-family: inherit;
    font-size: ${({ theme }) => toRem(theme.tokens.fonts.size['0875'])};
    font-weight: ${({ theme }) => theme.tokens.fonts.weight.bold};
    justify-content: center;
    line-height: ${({ theme }) => toRem(theme.tokens.fonts.lineHeight['0875'])};
    max-width: ${toRem(200)};
    min-width: 0;
    overflow-wrap: break-word;
    padding: ${({ theme }) => toRem(theme.tokens.padding.xs)} ${({ theme }) => toRem(theme.tokens.padding.sm)};
    word-break: break-word;
`;
